import Query from '../../components/Report';

const query = ({ offset = 0 }) => new Query('category-top-authors', { offset });

export default query;
